import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderJson(source) {
    var parts = split(source);
    var result = [];
    var isString = false;
    var isProperty = true;
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var token = parts_1[_i];
        if (token === ',' || token === '{') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            isProperty = true;
            continue;
        }
        if (token === ':') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            isProperty = false;
            continue;
        }
        if (token === '(' || token === ')' || token === '{' || token === '}' || token === '[' || token === ']') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            continue;
        }
        var color = isProperty ? Colors.attributeNameColor : Colors.attributeValueColor;
        result.push(_jsx("span", { style: { color: color }, children: token }));
    }
    return result;
}
